import site from '../../site';

import actionTypes from '../constants/action-types';
import constants from '../constants';

const DEFAULT_STATE = {
  status: constants.STATUS_PENDING,
  undo: [],
  redo: [],
};

const history = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes.UNDO:
      return {
        ...state,
        status: constants.STATUS_UNDO,
      };

    case actionTypes.REDO:
      return {
        ...state,
        status: constants.STATUS_REDO,
      };

    case actionTypes.SAVE_MUTATION: {
      switch (state.status) {
        case constants.STATUS_UNDO:
          return {
            undo: state.undo.slice(0, -1),
            redo: [action.payload.mutation, ...state.redo],
            status: constants.STATUS_PENDING,
          };

        case constants.STATUS_REDO:
          return {
            undo: [...state.undo, action.payload.mutation],
            redo: state.redo.slice(1),
            status: constants.STATUS_PENDING,
          };

        default:
          return {
            undo: [...state.undo, action.payload.mutation],
            redo: [],
            status: constants.STATUS_PENDING,
          };
      }
    }

    case actionTypes.SET_HISTORY:
      return action.payload.history;

    case actionTypes.CLEAR_HISTORY:
    case site.actionTypes.SET_ACTIVE_PAGE:
      return DEFAULT_STATE;

    case actionTypes.MERGE_HISTORY: {
      const { status, stepCount } = action.payload;

      if (status === constants.STATUS_UNDO) {
        return {
          ...state,
          undo: state.undo.slice(0, -stepCount),
        };
      }
      if (status === constants.STATUS_REDO) {
        return {
          ...state,
          redo: state.redo.slice(stepCount),
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default history;
